module.exports = __webpack_public_path__ + "img/contas-bancarias.6e51a9d9.svg";